<template>
  <div class="pt-10 pb-3 item">
    <div
      class="
        px-5
        grey--text
        text--darken-1 text-body-1 text-center
        position-relative
        ck-content
        item-text
      "
    >
      <div class="primary--text text-h1 quote quote-start">“</div>
      <span class="font-secondary" v-html="text"></span>
      <div class="primary--text text-h1 quote quote-end">“</div>
    </div>

    <div
      class="
        px-5
        grey--text
        text--darken-1 text-h5 text-center
        font-weight-bold
        mt-12
      "
    >
      <span class="font-secondary">
        {{ title }}
      </span>
    </div>

    <div class="text-center mt-3">
      <template v-for="star in stars">
        <v-icon :key="star" color="primary" size="18"> fa-star </v-icon>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    stars: {
      type: Number,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  .quote {
    height: 0;
    line-height: 0;
    position: absolute;
    width: 0;

    &.quote-start {
      left: 0;
      top: 10px;
    }

    &.quote-end {
      bottom: 10px;
      right: 0;
      transform: rotate(180deg);
    }
  }
}
</style>
